import { Injectable } from "@angular/core";
import { BaseApiClientAssessmentService } from "./base-api-client-assessment.service";

@Injectable({
  	providedIn: 'root'
})
export class ApiClientAssessmentsService extends BaseApiClientAssessmentService {}